import ZpTable from './src/table.vue'
export default ZpTable
